<template>
<svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-user2`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="svg_8f8d3f70ec__a"><stop stop-color="#3AD3D8" offset="0%"/><stop stop-color="#1BA8AF" offset="100%"/></linearGradient></defs><path d="M22,21.0877404 C22,16.6057692 18.8322115,12.7980769 14.4586538,11.4574519 C16.1588942,10.3389423 17.2853365,8.42451923 17.2853365,6.25096154 C17.2853365,2.80288462 14.4665865,0 11,0 C7.53341346,0 4.71466346,2.80288462 4.71466346,6.24831731 C4.71466346,8.421875 5.84110577,10.3362981 7.54134615,11.4548077 C3.16778846,12.7980769 0,16.603125 0,21.0877404 L0,22 L22,22 L22,21.1009615 L22,21.0877404 Z" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_8f8d3f70ec__a)'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmUser2',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
